<template>
  <div class="table-responsive">
    <table id="datatable-basic" class="table table-flush">
      <thead class="thead-light">
      <tr>
        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
          #
        </th>
        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
          {{ $t("Nome") }}
        </th>
        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
          {{ $t("Superficie") }}
        </th>
        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
          {{ $t("Postazioni") }}
        </th>
        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
          {{ $t("Serratura") }}
        </th>
        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" data-sortable="false">
          {{ $t("Azioni") }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="s in spazi" :key="'spazio-datatable-'+s.id">
        <td><strong>{{ s.id }}</strong></td>
        <td v-if="lang === 'it'">{{ s.nome }}</td>
        <td v-else-if="lang === 'en'">{{ s.nome_en }}</td>
        <td v-else-if="lang === 'de'">{{ s.nome_de }}</td>
        <td v-else></td>
        <td>{{ s.superficie }} mq</td>
        <td>{{ s.postazioni }}</td>
        <td>
          <serratura-type-badge :type="s.tipo_serratura"/>
        </td>
        <td>
          <router-link :to="{name:'Spazio', params:{id: s.id}}">
            <argon-button size="sm">{{$t('Vedi')}}</argon-button>
          </router-link>
          <router-link :to="{name:'Calendario', params:{id: s.id}}">
            <argon-button class="ms-1" size="sm" color="info"><span class="fa fa-calendar"></span></argon-button>
          </router-link>
          <argon-button class="ms-1" size="sm" color="info" @click.prevent="clone(s.id)">{{$t('Duplica')}}</argon-button>
          <argon-button class="ms-1" size="sm" color="danger" @click.prevent="remove(s.id)"><span class="fa fa-trash-can"></span></argon-button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { DataTable } from "simple-datatables";
import ArgonButton from "@/components/ArgonButton.vue";
import SerraturaTypeBadge from "@/thecomponents/SerraturaTypeBadge.vue";
import {mapState} from "vuex";
import {cloneModal, removeModal} from "@/modals";

export default {
  name: "SpaziDataTable",
  components: {
    SerraturaTypeBadge,
    ArgonButton
  },
  props: {
    spazi: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState(["lang"]),
  },
  mounted() {
    // eslint-disable-next-line no-unused-vars
    new DataTable("#datatable-basic", {
      searchable: true,
      fixedHeight: true,
      paging: false,
      labels: {
        placeholder: this.$t("Cerca..."),
        searchTitle: this.$t("Cerca nella tabella"),
        perPage: this.$t("elementi per pagina"),
        pageTitle: this.$t("Pagina page").replaceAll('[', '{').replaceAll(']', '}'),
        noRows: this.$t("Nessun elemento trovato"),
        noResults: this.$t("Nessun risultato per la tua query di ricerca"),
        info: this.$t("Risultati da start a end su rows").replaceAll('[', '{').replaceAll(']', '}'),
      }
    });
  },
  methods: {
    remove: function(id){
      removeModal(this, () => {
        this.apiClient.removeSpazio(id).then(() => {
          location.reload();//si, si dovrebbe fare una emit e intercettarla nel padre ecc.. non ho tempo
        });
      });
    },
    clone: function(id){
      cloneModal(this, () => {
        this.apiClient.cloneSpazio(id).then(() => {
          location.reload();
        });
      });
    },
  }
};
</script>
